export default __webpack_public_path__ + "static/media/mcaloon_incubation_period.44eaf5b3.png";